import { useState, useEffect } from "react";
import { images } from "../../constants/images";
import "../../assets/stylesheets/bootstrap.min.css";
import "../../assets/stylesheets/style.css";
import "../../assets/stylesheets/responsive.css";
import MobileAppStyles from "./MobileAppStyles";

export default function MobileAppDevelopment() {
  useEffect(() => {
    document.title = "Custom Mobile App Development | Plural Code";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mobile-app-page">
      {/* HERO SECTION - Same as home page */}
      <section
        className="mobile-app-hero"
        style={{
          minHeight: "85vh",
          display: "flex",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, #0a2458 0%, #1a3b8a 30%, #2a4ba8 70%, #3a5dc8 100%)",
        }}
      >
        {/* Background Elements */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
            radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(10, 36, 88, 0.2) 0%, transparent 50%)
          `,
          }}
        />

        <div className="container">
          <div className="hero-content">
            {/* Breadcrumb */}

            <div className="row align-items-center min-vh-85">
              <div className="col-lg-7 col-md-12 mb-5 mb-lg-0">
                <div
                  className="text-white position-relative"
                  style={{ zIndex: 2 }}
                >
                  {/* Badge */}
                  <div
                    className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4"
                    style={{
                      background: "rgba(255, 215, 0, 0.15)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 215, 0, 0.3)",
                    }}
                  >
                    <span style={{ fontSize: "20px" }}>📱</span>
                    <span
                      className="fw-bold"
                      style={{ fontSize: "14px", color: "#FFD700" }}
                    >
                      MOBILE FIRST APPROACH
                    </span>
                  </div>

                  {/* Main Heading */}
                  <h1
                    className="display-3 fw-bold mb-4"
                    style={{
                      lineHeight: "1.1",
                      background:
                        "linear-gradient(to right, #FFFFFF 0%, #E6F0FF 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      textShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    }}
                  >
                    Custom Mobile App
                    <span
                      className="d-inline-block mt-2"
                      style={{
                        background:
                          "linear-gradient(90deg, #FFD700 0%, #FFEC8B 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        position: "relative",
                        padding: "0 5px",
                      }}
                    >
                      Development
                    </span>
                  </h1>

                  {/* Subtitle */}
                  <p
                    className="fs-5 mb-5"
                    style={{
                      color: "#E6F0FF",
                      lineHeight: "1.6",
                      maxWidth: "90%",
                      fontWeight: "300",
                    }}
                  >
                    Native and cross-platform mobile applications built
                    specifically for your business—putting powerful tools in
                    your team's pockets or reaching customers on their devices.
                  </p>

                  {/* CTA Buttons */}
                  <div className="d-flex flex-wrap gap-3 mb-5">
                    <button
                      onClick={() =>
                        (window.location.href =
                          "https://topmate.io/pluralcode/1677497")
                      }
                      className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                      style={{
                        background:
                          "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                        border: "none",
                        color: "#0a2458",
                        fontWeight: "700",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                        boxShadow: "0 10px 30px rgba(255, 215, 0, 0.3)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-3px)";
                        e.target.style.boxShadow =
                          "0 15px 40px rgba(255, 215, 0, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 10px 30px rgba(255, 215, 0, 0.3)";
                      }}
                    >
                      <span>💬</span>
                      <span>Discuss Your Mobile App</span>
                    </button>

                    <button
                      onClick={() => (window.location.href = "/case-studies")}
                      className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                      style={{
                        background: "transparent",
                        border: "2px solid #FFD700",
                        color: "#FFD700",
                        fontWeight: "600",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                        backdropFilter: "blur(10px)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = "rgba(255, 215, 0, 0.1)";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = "transparent";
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      <span>📊</span>
                      <span>See Mobile Projects</span>
                    </button>
                  </div>

                  {/* Trust Indicators */}
                  <div className="d-flex flex-wrap align-items-center gap-4">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ fontSize: "24px", color: "#FFD700" }}>
                        ✅
                      </div>
                      <span style={{ color: "#E6F0FF" }}>
                        Native & Cross-Platform
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ fontSize: "24px", color: "#FFD700" }}>
                        ✅
                      </div>
                      <span style={{ color: "#E6F0FF" }}>iOS & Android</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ fontSize: "24px", color: "#FFD700" }}>
                        ✅
                      </div>
                      <span style={{ color: "#E6F0FF" }}>
                        Offline Capabilities
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Hero Image */}
              <div className="col-lg-5 col-md-12">
                <div className="position-relative">
                  <div
                    style={{
                      position: "relative",
                      padding: "20px",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        bottom: "0",
                        left: "0",
                        background:
                          "linear-gradient(135deg, rgba(255,215,0,0.15) 0%, rgba(255,215,0,0) 50%)",
                        borderRadius: "25px",
                        transform: "rotate(5deg)",
                        zIndex: 0,
                      }}
                    />

                    <div
                      style={{
                        position: "relative",
                        borderRadius: "20px",
                        overflow: "hidden",
                        boxShadow: "0 25px 50px rgba(0,0,0,0.4)",
                        transform:
                          "perspective(1000px) rotateY(-5deg) rotateX(2deg)",
                        transition: "transform 0.5s ease",
                        zIndex: 1,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "perspective(1000px) rotateY(0deg) rotateX(0deg)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "perspective(1000px) rotateY(-5deg) rotateX(2deg)";
                      }}
                    >
                      <img
                        src={images?.mobileservice}
                        className="img-fluid w-100"
                        alt="Mobile App Development"
                        style={{
                          display: "block",
                          height: "auto",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>

                  {/* Floating Stats Cards */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-30px",
                      left: "-20px",
                      background: "rgba(255, 255, 255, 0.95)",
                      backdropFilter: "blur(10px)",
                      padding: "20px",
                      borderRadius: "15px",
                      boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                      width: "250px",
                      zIndex: 2,
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "24px",
                        }}
                      >
                        📈
                      </div>
                      <div>
                        <div
                          className="fw-bold fs-4"
                          style={{ color: "#0a2458" }}
                        >
                          40%
                        </div>
                        <div className="fs-12" style={{ color: "#0A2458" }}>
                          Increase in Engagement
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      top: "-20px",
                      right: "-10px",
                      background: "rgba(255, 215, 0, 0.95)",
                      backdropFilter: "blur(10px)",
                      padding: "15px",
                      borderRadius: "15px",
                      boxShadow: "0 15px 35px rgba(255, 215, 0, 0.3)",
                      width: "200px",
                      zIndex: 2,
                    }}
                  >
                    <div className="text-center">
                      <div
                        className="fw-bold fs-4"
                        style={{ color: "#0a2458" }}
                      >
                        3-5
                      </div>
                      <div className="fs-12" style={{ color: "#0a2458" }}>
                        Months Development
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY MOBILE APPS MATTER */}
      <section className="why-mobile-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="position-relative">
                <img
                  src={images?.whyBusinessNeedsMobileApp}
                  className="img-fluid rounded-4"
                  alt="Why Mobile Apps Matter"
                  style={{
                    boxShadow: "0 20px 40px rgba(10, 36, 88, 0.1)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-20px",
                    width: "80px",
                    height: "80px",
                    background: "#FFD700",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "32px",
                    boxShadow: "0 10px 20px rgba(255, 215, 0, 0.3)",
                  }}
                >
                  📱
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-4">
                <span
                  className="px-3 py-1 rounded-pill d-inline-block mb-3"
                  style={{
                    background: "rgba(10, 36, 88, 0.1)",
                    color: "#0a2458",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  MOBILE ADVANTAGE
                </span>
                <h2
                  className="tc-primary head-font mb-4"
                  style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
                >
                  Why Your Business Needs a Mobile App
                </h2>
                <p
                  className="head-font2 tc-primary fs-17 mb-4"
                  style={{ color: "#0A2458" }}
                >
                  The world is mobile-first. Your customers and employees expect
                  mobile access. A custom mobile app gives you:
                </p>
              </div>

              <div className="row g-3">
                {[
                  {
                    icon: "📱",
                    title: "Always Accessible",
                    desc: "Your app is literally in their pocket—available anytime, anywhere, even offline.",
                  },
                  {
                    icon: "⚡",
                    title: "Better User Experience",
                    desc: "Native apps are faster, smoother, and more intuitive than mobile websites.",
                  },
                  {
                    icon: "🔔",
                    title: "Direct Communication",
                    desc: "Push notifications let you reach users instantly—updates, reminders, promotions.",
                  },
                  {
                    icon: "📊",
                    title: "Competitive Edge",
                    desc: "A well-built mobile app positions you as modern and professional—ahead of competitors.",
                  },
                ].map((item, index) => (
                  <div className="col-lg-6" key={index}>
                    <div
                      className="p-3 rounded-3 h-100"
                      style={{
                        background: "white",
                        border: "1px solid rgba(10, 36, 88, 0.1)",
                        boxShadow: "0 5px 15px rgba(10, 36, 88, 0.05)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 15px 30px rgba(10, 36, 88, 0.1)";
                        e.currentTarget.style.borderColor = "#0a2458";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 5px 15px rgba(10, 36, 88, 0.05)";
                        e.currentTarget.style.borderColor =
                          "rgba(10, 36, 88, 0.1)";
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                          style={{
                            fontSize: "24px",
                            width: "50px",
                            height: "50px",
                            background: "rgba(10, 36, 88, 0.1)",
                          }}
                        >
                          {item.icon}
                        </div>
                        <div>
                          <h3 className="tc-primary head-font fs-18 mb-1">
                            {item.title}
                          </h3>
                          <p
                            className="head-font2 tc-primary fs-14 mb-0"
                            style={{ color: "#0A2458" }}
                          >
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Mobile App vs Mobile Website Table */}
          <div className="mt-5 pt-5">
            <div className="text-center mb-5">
              <h3
                className="tc-primary head-font mb-4"
                style={{ fontSize: "clamp(1.75rem, 3vw, 2.25rem)" }}
              >
                Mobile App vs Mobile Website
              </h3>
              <p
                className="head-font2 tc-primary fs-18"
                style={{
                  color: "#0A2458",
                  maxWidth: "700px",
                  margin: "0 auto",
                }}
              >
                Understand the key differences to make the right choice for your
                business
              </p>
            </div>

            <div className="comparison-table">
              <div className="table-header">
                <div className="feature-col">
                  <strong>Feature</strong>
                </div>
                <div className="website-col">
                  <strong>Mobile Website</strong>
                </div>
                <div className="app-col">
                  <strong>Mobile App</strong>
                </div>
              </div>

              {[
                {
                  feature: "Performance",
                  website: "Slower, depends on connection",
                  app: "Fast, responsive",
                },
                {
                  feature: "Offline Access",
                  website: "Limited/none",
                  app: "Yes (if designed)",
                },
                { feature: "Push Notifications", website: "No", app: "Yes" },
                {
                  feature: "Device Features",
                  website: "Limited access",
                  app: "Camera, GPS, sensors",
                },
                {
                  feature: "User Experience",
                  website: "Good",
                  app: "Excellent",
                },
                {
                  feature: "Installation",
                  website: "None needed",
                  app: "Download from store",
                },
              ].map((row, index) => (
                <div key={index} className="table-row">
                  <div className="feature-col">
                    <strong>{row.feature}</strong>
                  </div>
                  <div className="website-col">
                    <span className="badge bg-light text-dark">
                      {row.website}
                    </span>
                  </div>
                  <div className="app-col">
                    <span
                      className="badge"
                      style={{
                        background:
                          "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                        color: "white",
                      }}
                    >
                      {row.app}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* TYPES OF MOBILE APPS */}
      <section className="app-types-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR SOLUTIONS
            </span>
            <h2
              className="tc-primary head-font mb-4"
              style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
            >
              Mobile Applications We Develop
            </h2>
            <p
              className="head-font2 tc-primary fs-18 mx-auto"
              style={{ maxWidth: "700px", color: "#0A2458" }}
            >
              From business productivity to customer engagement, we build mobile
              apps that solve real business problems
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                icon: "💼",
                title: "Business Productivity Apps",
                desc: "Tools that help your team work more efficiently—on the go or in the field.",
                features: [
                  "Task & workflow management",
                  "Time tracking & attendance",
                  "Document access & capture",
                  "Real-time team communication",
                ],
                perfectFor: [
                  "Field service teams",
                  "Sales representatives",
                  "Remote/mobile workforces",
                ],
                example:
                  "Field service app for HVAC company—technicians log jobs, capture photos, update status—all offline-capable.",
              },
              {
                icon: "👥",
                title: "Customer-Facing Mobile Apps",
                desc: "Apps that put your services directly in customers' hands—improving engagement and convenience.",
                features: [
                  "Account management",
                  "Product browsing & ordering",
                  "Appointment booking",
                  "Loyalty programs & rewards",
                ],
                perfectFor: [
                  "Retail & e-commerce",
                  "Service businesses",
                  "Membership organizations",
                ],
                example:
                  "Restaurant chain app—customers browse menu, customize orders, pay in-app, earn loyalty points.",
              },
              {
                icon: "📝",
                title: "Field Data Collection Apps",
                desc: "Eliminate clipboards and spreadsheets—capture data directly on mobile devices.",
                features: [
                  "Custom form builders",
                  "Photo & signature capture",
                  "GPS tagging",
                  "Offline data capture",
                ],
                perfectFor: [
                  "Inspection services",
                  "Research & surveys",
                  "Quality control teams",
                ],
                example:
                  "Construction site inspection app—inspectors complete checklists, capture photos, generate instant PDF reports.",
              },
              {
                icon: "🔌",
                title: "IoT-Connected Apps",
                desc: "Mobile apps that control or monitor physical devices and sensors.",
                features: [
                  "Real-time device monitoring",
                  "Remote control capabilities",
                  "Alert & notification systems",
                  "Data visualization",
                ],
                perfectFor: [
                  "Manufacturing with smart equipment",
                  "Facilities management",
                  "Agriculture & monitoring",
                ],
                example:
                  "Agricultural monitoring app—farmers check soil moisture, temperature, control systems remotely.",
              },
              {
                icon: "🛒",
                title: "Marketplace & Platform Apps",
                desc: "Two-sided platforms connecting service providers with customers.",
                features: [
                  "Separate apps for providers & customers",
                  "Real-time matching",
                  "In-app messaging",
                  "Payment processing",
                ],
                perfectFor: [
                  "On-demand services",
                  "Freelance platforms",
                  "Rental/sharing businesses",
                ],
                example:
                  "Home services marketplace—customers request services, nearby providers receive notifications, accept jobs.",
              },
              {
                icon: "🏢",
                title: "Enterprise Mobile Extensions",
                desc: "Mobile companions to your existing business software—giving mobile access to key functions.",
                features: [
                  "Streamlined mobile workflows",
                  "Dashboard & reporting access",
                  "Approval & notification handling",
                  "Syncs with main system",
                ],
                perfectFor: [
                  "Companies with existing web systems",
                  "Teams needing mobile access",
                  "Businesses with desktop software",
                ],
                example:
                  "Inventory management mobile app—warehouse staff update inventory, scan barcodes, check stock levels.",
              },
            ].map((type, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="app-type-card h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 25px 50px rgba(10, 36, 88, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(10, 36, 88, 0.08)";
                  }}
                >
                  <div className="app-icon">{type.icon}</div>
                  <h3>{type.title}</h3>
                  <p className="app-desc">{type.desc}</p>

                  <div className="app-details">
                    <div className="detail-section">
                      <strong>Perfect for:</strong>
                      <ul>
                        {type.perfectFor.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="detail-section">
                      <strong>Common features:</strong>
                      <ul>
                        {type.features.map((feature, i) => (
                          <li key={i}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="example-box">
                    <strong>Example:</strong> {type.example}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* NATIVE VS CROSS-PLATFORM */}
      <section className="platform-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              DEVELOPMENT APPROACH
            </span>
            <h2
              className="tc-primary head-font mb-4"
              style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
            >
              Native vs Cross-Platform: Which is Right for You?
            </h2>
            <p
              className="head-font2 tc-primary fs-18 mx-auto"
              style={{ maxWidth: "700px", color: "#0A2458" }}
            >
              There are two main approaches to mobile app development. We'll
              help you choose the right one.
            </p>
          </div>

          <div className="platform-comparison">
            <div className="row g-4">
              <div className="col-lg-6">
                <div className="platform-card native">
                  <div className="card-header">
                    <div className="platform-icon">🍎</div>
                    <h3>Native Development</h3>
                    <span className="platform-subtitle">
                      Separate apps for iOS (Swift) and Android (Kotlin)
                    </span>
                  </div>

                  <div className="pros-cons">
                    <div className="pros">
                      <h4>✅ Pros:</h4>
                      <ul>
                        <li>
                          <strong>Best performance & speed</strong>
                        </li>
                        <li>
                          <strong>Full access to device features</strong>
                        </li>
                        <li>
                          <strong>Best user experience</strong>
                        </li>
                        <li>
                          <strong>Latest platform features immediately</strong>
                        </li>
                      </ul>
                    </div>

                    <div className="cons">
                      <h4>⚠️ Cons:</h4>
                      <ul>
                        <li>Higher cost (two separate codebases)</li>
                        <li>Longer development time</li>
                        <li>Requires maintaining two apps</li>
                      </ul>
                    </div>
                  </div>

                  <div className="best-for">
                    <h4>Best for:</h4>
                    <ul>
                      <li>Apps needing maximum performance</li>
                      <li>Heavy graphics or processing</li>
                      <li>Cutting-edge device features</li>
                      <li>Large budgets prioritizing quality</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="platform-card cross-platform highlighted">
                  <div className="recommended-badge">RECOMMENDED</div>
                  <div className="card-header">
                    <div className="platform-icon">⚛️</div>
                    <h3>Cross-Platform Development</h3>
                    <span className="platform-subtitle">
                      One codebase runs on both iOS and Android (React Native)
                    </span>
                  </div>

                  <div className="pros-cons">
                    <div className="pros">
                      <h4>✅ Pros:</h4>
                      <ul>
                        <li>
                          <strong>Faster development (one codebase)</strong>
                        </li>
                        <li>
                          <strong>Lower cost (~30-40% savings)</strong>
                        </li>
                        <li>
                          <strong>Easier maintenance</strong>
                        </li>
                        <li>
                          <strong>
                            Consistent experience across platforms
                          </strong>
                        </li>
                      </ul>
                    </div>

                    <div className="cons">
                      <h4>⚠️ Cons:</h4>
                      <ul>
                        <li>Slightly slower than native</li>
                        <li>Some advanced features limited</li>
                        <li>Occasional platform-specific quirks</li>
                      </ul>
                    </div>
                  </div>

                  <div className="best-for">
                    <h4>Best for:</h4>
                    <ul>
                      <li>Most business applications</li>
                      <li>Budget-conscious projects</li>
                      <li>Faster time to market</li>
                      <li>Apps without heavy processing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="recommendation-box">
              <div className="recommendation-icon">💡</div>
              <div className="recommendation-content">
                <h3>Our Recommendation</h3>
                <p>
                  We typically recommend{" "}
                  <strong>React Native (cross-platform)</strong> for most
                  business apps because it delivers
                  <strong> 90% of native performance at 60% of the cost</strong>
                  , covers 99% of use cases perfectly, and gets you to market
                  3-5 months faster than native development.
                </p>
                <div className="stats-grid">
                  <div className="stat">
                    <div className="stat-value">90%</div>
                    <div className="stat-label">Native Performance</div>
                  </div>
                  <div className="stat">
                    <div className="stat-value">40%</div>
                    <div className="stat-label">Cost Savings</div>
                  </div>
                  <div className="stat">
                    <div className="stat-value">3-5</div>
                    <div className="stat-label">Months Faster</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OUR PROCESS */}
      <section className="process-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR PROCESS
            </span>
            <h2
              className="tc-primary head-font mb-4"
              style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
            >
              How We Build Your Mobile App
            </h2>
            <p
              className="head-font2 tc-primary fs-18 mx-auto"
              style={{ maxWidth: "700px", color: "#0A2458" }}
            >
              Mobile apps require careful UX design, platform considerations,
              and rigorous testing.
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                step: "1",
                title: "Discovery & Strategy",
                duration: "1-2 weeks",
                desc: "Understanding your mobile app vision, user journeys, and requirements.",
                points: [
                  "Define target users",
                  "Map user journeys & workflows",
                  "Platform decision",
                  "Offline requirements assessment",
                ],
              },
              {
                step: "2",
                title: "UX/UI Design",
                duration: "2-3 weeks",
                desc: "Designing for mobile-first experience with user testing.",
                points: [
                  "Create user flow diagrams",
                  "Design wireframes",
                  "High-fidelity mockups",
                  "Interactive prototype",
                ],
              },
              {
                step: "3",
                title: "Technical Architecture",
                duration: "1 week",
                desc: "Planning the technical foundation and integrations.",
                points: [
                  "App architecture design",
                  "Database schema planning",
                  "API structure",
                  "Security implementation",
                ],
              },
              {
                step: "4",
                title: "Development",
                duration: "8-14 weeks",
                desc: "Building in 2-week agile sprints with weekly builds.",
                points: [
                  "Frontend development",
                  "Backend API development",
                  "Third-party integrations",
                  "Weekly testing builds",
                ],
              },
              {
                step: "5",
                title: "Testing & QA",
                duration: "2-3 weeks",
                desc: "Ensuring quality across devices and scenarios.",
                points: [
                  "Functional testing",
                  "Device testing",
                  "Performance testing",
                  "Network testing",
                ],
              },
              {
                step: "6",
                title: "App Store Launch",
                duration: "1-2 weeks",
                desc: "Getting your app live in app stores.",
                points: [
                  "App Store listing preparation",
                  "Submission & review",
                  "Analytics setup",
                  "User documentation",
                ],
              },
            ].map((step, index) => (
              <div key={index} className="process-step">
                <div className="step-number">{step.step}</div>
                <div className="step-content">
                  <div className="step-header">
                    <h3>{step.title}</h3>
                    <span className="step-duration">({step.duration})</span>
                  </div>
                  <p className="step-desc">{step.desc}</p>
                  <ul className="step-points">
                    {step.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TECHNOLOGIES */}
      <section className="technologies-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              TECHNOLOGY STACK
            </span>
            <h2
              className="tc-primary head-font mb-4"
              style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
            >
              Technologies We Use for Mobile Development
            </h2>
            <p
              className="head-font2 tc-primary fs-18 mx-auto"
              style={{ maxWidth: "700px", color: "#0A2458" }}
            >
              We choose the right technology based on your specific needs and
              business requirements.
            </p>
          </div>

          <div className="row g-4">
            <div className="col-lg-6">
              <div className="tech-card primary">
                <div className="tech-badge">PRIMARY CHOICE</div>
                <div className="tech-header">
                  <div className="tech-icon">⚛️</div>
                  <h3>Cross-Platform (React Native)</h3>
                </div>
                <ul className="tech-features">
                  <li>✅ Single codebase for iOS & Android</li>
                  <li>✅ Native performance for most use cases</li>
                  <li>✅ 30-40% cost savings vs native</li>
                  <li>✅ Large community & library ecosystem</li>
                  <li>✅ Used by Facebook, Instagram, Uber, Discord</li>
                </ul>
                <div className="tech-perfect">
                  <strong>Perfect for:</strong> 90% of business applications
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="tech-card">
                <div className="tech-header">
                  <div className="tech-icon">🍎🤖</div>
                  <h3>Native Development</h3>
                </div>
                <div className="native-details">
                  <div className="native-platform">
                    <h4>iOS (Swift)</h4>
                    <ul>
                      <li>Maximum performance on iPhones/iPads</li>
                      <li>Best iOS user experience</li>
                      <li>Full Apple ecosystem integration</li>
                    </ul>
                  </div>
                  <div className="native-platform">
                    <h4>Android (Kotlin)</h4>
                    <ul>
                      <li>Maximum performance on Android devices</li>
                      <li>Full Android capabilities</li>
                      <li>Deep device integration</li>
                    </ul>
                  </div>
                </div>
                <div className="tech-perfect">
                  <strong>Perfect for:</strong> Performance-critical apps,
                  cutting-edge features
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="tech-card">
                <div className="tech-header">
                  <div className="tech-icon">⚙️</div>
                  <h3>Backend & Infrastructure</h3>
                </div>
                <div className="tech-features">
                  <li>
                    <strong>API Backend:</strong> Ruby on Rails, RESTful APIs,
                    PostgreSQL
                  </li>
                  <li>
                    <strong>Cloud Infrastructure:</strong> AWS, Push
                    notifications, File storage
                  </li>
                  <li>
                    <strong>Real-time capabilities</strong> when needed
                  </li>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="tech-card">
                <div className="tech-header">
                  <div className="tech-icon">🔗</div>
                  <h3>Integrations & Capabilities</h3>
                </div>
                <div className="row">
                  <div className="col-6">
                    <ul className="tech-features">
                      <li>✅ Offline functionality</li>
                      <li>✅ Push notifications</li>
                      <li>✅ Camera & media</li>
                      <li>✅ GPS & location</li>
                    </ul>
                  </div>
                  <div className="col-6">
                    <ul className="tech-features">
                      <li>✅ Biometric auth</li>
                      <li>✅ Payment processing</li>
                      <li>✅ Real-time sync</li>
                      <li>✅ Device sensors</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta-section">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="head-font fs-44 mb-4" style={{ color: "white" }}>
              Ready to Build Your Mobile App?
            </h2>
            <p
              className="head-font2 fs-20 mb-5 mx-auto"
              style={{
                color: "rgba(255, 255, 255, 0.9)",
                maxWidth: "700px",
              }}
            >
              Let's discuss your mobile app idea, who will use it, and what it
              needs to do. We'll help determine the best approach and what's
              involved.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="cta-card">
                <div className="cta-icon">💬</div>
                <h3>Free Consultation</h3>
                <p>
                  30-minute call to discuss your mobile app concept and
                  requirements
                </p>
                <button
                  onClick={() =>
                    (window.location.href =
                      "https://topmate.io/pluralcode/1677497")
                  }
                  className="cta-btn primary"
                >
                  Schedule Free Call →
                </button>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="cta-card">
                <div className="cta-icon">📋</div>
                <h3>Project Inquiry</h3>
                <p>Send us details about your app idea and requirements</p>
                <button
                  onClick={() =>
                    (window.location.href =
                      "https://topmate.io/pluralcode/1677497?type=project")
                  }
                  className="cta-btn primary"
                >
                  Discuss Your App Idea →
                </button>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="cta-card">
                <div className="cta-icon">📊</div>
                <h3>Explore Resources</h3>
                <p>Access our free tools, calculators, and case studies</p>
                <button
                  onClick={() => window.open("/lm/tools", "_blank")}
                  className="cta-btn secondary"
                >
                  Free Resources →
                </button>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <div className="row">
              <div className="col-md-4">
                <div className="info-item">
                  <div className="info-icon">📧</div>
                  <div>
                    <div className="info-label">Email</div>
                    <div className="info-value">info@pluralcode.com</div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div>
                    <div className="info-label">Call</div>
                    <div className="info-value">+91 9958920231</div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="info-item">
                  <div className="info-icon">🌏</div>
                  <div>
                    <div className="info-label">Serving</div>
                    <div className="info-value">
                      US, Australia, NZ, Singapore, Canada, India
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <MobileAppStyles />
    </div>
  );
}
